import { browserHistory } from '../../containers/App'

export const historyPush = path => browserHistory.push(path)
export const moveTopPage = () => historyPush('/')
